<template>
    <v-app id="inspector-admin">
        <v-navigation-drawer app permanent dark width="200">
            <div class="logo" />

            <v-list class="mt-3" v-if="$store.state.user.logged">
                <v-divider class="mb-3"></v-divider>

                <v-list-item
                        v-for="item in itemsFiltered"
                        :key="item.title"
                        :to="{name:item.page}"
                        :disable="item.disabled"
                >
                    <v-list-item-action>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app>
<!--            <v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->

            <v-toolbar-title @click="$router.push({name:'home'})">
                Bzuco Inspector Administrace
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn text color="orange" @click="$router.push({name:'help'})">
                <v-icon left>help</v-icon>
                Nápověda
            </v-btn>

            <v-spacer></v-spacer>

            <span v-if="loggedUser">
                Přihlášený uživatel:
                <strong>
                    {{loggedUser.firstName}}
                    {{loggedUser.lastName}}
                </strong>
            </span>
            <span v-if="loggedUser===null">
                - Nepřihlášen -
            </span>

            <v-btn color="success" class="ml-5"
                   v-if="loggedUser === null"
                   :to="{name:'login'}"
                   title="Přihlásit"
            >
                <v-icon left>power</v-icon>
                Přihlásit
            </v-btn>
            <v-btn class="ml-5"
                   v-if="loggedUser"
                   title="Odhlásit"
                   @click="logout"
            >
                <v-icon left>power_off</v-icon>
                Odhlásit
            </v-btn>
        </v-app-bar>

        <v-snackbar v-model="$store.state.storeError" color="error">
            {{ $store.state.storeErrorMessage }}
            <v-btn
                    text depressed
                    color="error"
                    @click="$store.commit('hideStoreError')"
            >
                Zavřít
            </v-btn>
        </v-snackbar>

        <v-main>
            <v-container fluid class="fill-height align-content-start">
                <router-view/>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

    export default {
        name: 'App',
        data() {
            return {
                items: [
                    {
                        icon: 'person',
                        title: 'Uživatelé',
                        page: 'users',
                        superuser: true
                    },
                    {
                        icon: 'event',
                        title: 'Události',
                        page: 'events'
                    },
                    {
                        icon: 'pie_chart',
                        title: 'Sady vstupenek',
                        page: 'ticketsets'
                    },
                    {
                        icon: 'receipt',
                        title: 'Vstupenky',
                        page: 'tickets'
                    },
                    {
                        icon: 'devices',
                        title: 'Zařízení',
                        page: 'devices'
                    },
                    // {
                    //     icon: 'category',
                    //     title: 'Kontrolní místa',
                    //     page: 'checkpoints'
                    // },
                    {
                        icon: 'bar_chart',
                        title: 'Statistiky',
                        page: 'statistics'
                    },
                ]
            }
        },
        computed: {
            loggedUser () {
                return this.$store.state.user.logged
            },
            itemsFiltered () {
                if (this.$store.state.user.logged && this.$store.state.user.logged.isSuperuser) {
                    return this.items
                } else {
                    return this.items.filter(item => !item.superuser)
                }
            }
        },

        methods: {
            logout () {
                this.$store.dispatch('user/logout')
                this.$router.push({name:'home'})
            }
        }
    }
</script>

<style lang="scss">
    .logo {
        margin-top: 10px;
        background: url("assets/logo-home-bzuco.png");
        background-size: 90%;
        background-repeat: no-repeat;
        background-position: center center;
        width: 100%;
        height: 90px;
    }
</style>
